import { Component, createRef } from "react";
import { connect } from "react-redux";

import {
  set_datapage,
  getMapStateDefault,
} from "@ora/recursos/src/redux/actions/DataPageAction";
import { Templates } from "@ora/recursos";
import {
  checkDataDirectorio,
  // seDataDirectorio,
  seDatatDocumentos,
} from "@ora/recursos/src/redux/actions/DirectoriosActions";
import Swal from "sweetalert2";
import { Card, Section } from "react-bulma-components";
import axios from "axios";
import { baseUrl, localUrl } from "@ora/recursos/src/helpers/Url";
import InputsCreate from "layouts/mainsection/components/InputsCreate";
import "@loadingio/loading.css/dist/loading.css";

class PermisosCreate extends Component {
  isEdit = false;
  _isMounted = false;
  requestInit = null;
  inputs = [];
  idrecurso = 0;
  state = {
    recursos: [],
    tipo: [],
    idioma: [],
    data: null,
  };
  constructor(props) {
    super(props);

    this.frmCreate = createRef();
    this.refTxtUrl = createRef();
    let { idrecurso } = this.props.match.params;
    if (idrecurso !== undefined) {
      this.isEdit = true;
      this.idrecurso = idrecurso;
    }
    this.spinnerLoad = createRef();
  }
  componentWillUnmount() {
    this._isMounted = false;
    if (this.requestInit) this.requestInit.cancel();
  }
  componentDidMount() {
    this._isMounted = true;
    this.requestInit = axios.CancelToken.source();

    this.props.set_datapage({
      titulo: (this.isEdit ? "Editar" : "Crear") + " permisos",
      isbackend: true,
      breadcrumb: [
        { name: "Intranet", url: "#" },
        { name: "Permisos", url: "#" },
        {
          name: (this.isEdit ? "Editar" : "Crear") + " permisos",
          url: "#",
          active: true,
        },
      ],
    });

    axios
      .get(baseUrl("cites/permisos/create"), {
        cancelToken: this.requestInit.token,
      })
      .then((res) => {
        this.inputs = res.data.data;
      })
      .then((successC) => {
        axios
          .get(baseUrl("cites/permisos"), {
            cancelToken: this.requestInit.token,
          })
          .then((res) => {
            if (res.data.success) {
              this.setState({
                recursos: res.data.data.recursos,
                tipo: res.data.data.tipo,
                // mimes: res.data.data.mimes,
                //pais: res.data.data.paises,
                idioma: res.data.data.idioma,
                // sublinea: res.data.data.sublinea,
              });
            }
          })
          .then((success) => {
            if (this.isEdit) {
              axios
                .get(baseUrl("cites/permisos/" + this.idrecurso), {
                  cancelToken: this.requestInit.token,
                })
                .then((res) => {
                  if (res.data.success) {
                    this.frmCreate.current.elements.per_int_year.value =
                      res.data.data.per_int_year;
                    this.frmCreate.current.elements.per_text_number.value =
                      res.data.data.per_text_number;
                    this.frmCreate.current.elements.per_text_type.value =
                      res.data.data.per_text_type;
                    this.frmCreate.current.elements.per_text_date.value =
                      res.data.data.per_text_date;
                    this.frmCreate.current.elements.per_text_situation.value =
                      res.data.data.per_text_situation;
                    this.frmCreate.current.elements.per_text_datesituation.value =
                      res.data.data.per_text_datesituation;
                    this.frmCreate.current.elements.per_text_dateemission.value =
                      res.data.data.per_text_dateemission;
                    this.frmCreate.current.elements.per_text_exporter.value =
                      res.data.data.per_text_exporter;
                    this.frmCreate.current.elements.per_text_exportercountry.value =
                      res.data.data.per_text_exportercountry;
                    this.frmCreate.current.elements.per_text_exportercity.value =
                      res.data.data.per_text_exportercity;
                    this.frmCreate.current.elements.per_text_exportcountry.value =
                      res.data.data.per_text_exportcountry;
                    this.frmCreate.current.elements.per_text_importer.value =
                      res.data.data.per_text_importer;
                    this.frmCreate.current.elements.per_text_importercountry.value =
                      res.data.data.per_text_importercountry;
                    this.frmCreate.current.elements.per_text_importercity.value =
                      res.data.data.per_text_importercity;
                    this.frmCreate.current.elements.per_text_importcountry.value =
                      res.data.data.per_text_importcountry;
                    this.frmCreate.current.elements.per_text_operationobjective.value =
                      res.data.data.per_text_operationobjective;
                    this.frmCreate.current.elements.per_text_inputoutputlocation.value =
                      res.data.data.per_text_inputoutputlocation;
                    this.frmCreate.current.elements.per_text_inputoutputcity.value =
                      res.data.data.per_text_inputoutputcity;
                    this.frmCreate.current.elements.per_text_inputoutputdate.value =
                      res.data.data.per_text_inputoutputdate;
                    this.frmCreate.current.elements.per_text_observation.value =
                      res.data.data.per_text_observation;
                    this.frmCreate.current.elements.per_text_product.value =
                      res.data.data.per_text_product;
                    this.frmCreate.current.elements.per_text_taxon.value =
                      res.data.data.per_text_taxon;
                    this.frmCreate.current.elements.per_text_cite.value =
                      res.data.data.per_text_cite;
                    this.frmCreate.current.elements.per_text_originspecies.value =
                      res.data.data.per_text_originspecies;
                    this.frmCreate.current.elements.per_text_partspecies.value =
                      res.data.data.per_text_partspecies;
                    this.frmCreate.current.elements.per_int_quantity.value =
                      res.data.data.per_int_quantity;

                    this.frmCreate.current.elements.rec_int_id.value =
                      res.data.data.rec_int_id;

                    this.frmCreate.current.elements.lan_txt_language.value =
                      res.data.data.lan_txt_language;

                    this.frmCreate.current.elements.per_text_unit.value =
                      res.data.data.per_text_unit;

                    this.inputs.forEach((item, index) => {
                      if (
                        this.frmCreate.current.elements[item.key] !== undefined
                      ) {
                        switch (item.key) {
                          default:
                            this.frmCreate.current.elements[item.key].value =
                              res.data.data[item.key];
                            break;
                        }
                      }
                    });
                    this.spinnerLoad.current.classList.add("is-hidden");
                    this.frmCreate.current.classList.remove("is-hidden");
                  }
                });
            } else {
              this.spinnerLoad.current.classList.add("is-hidden");
              this.frmCreate.current.classList.remove("is-hidden");
            }
          });
      });

    // axios.get(baseUrl('cites/pais/actives')).then(res => {
    //   if (res.data.success) {
    //       this.setState({
    //           pais: res.data.data
    //       })
    //   }
    // })
    // axios.get(baseUrl('aro/lenguaje/actives')).then(res => {
    //   if (res.data.success) {
    //       this.setState({
    //           idioma: res.data.data
    //       })
    //   }
    // })
  }
  componentDidUpdate() {}
  onChange = (evt) => {
    // if (evt.target.name === 'duc_txt_file') {
    //   console.log(evt.target.files)
    //   if (evt.target.files.length > 0)
    //   this.refTxtUrl.current.value = evt.target.files[0].name
    // }
  };
  onClick_regresar = (evt) => {
    this.props.history.push(localUrl("/config/permisos"));
  };
  OnSubmit_create = (evt) => {
    evt.preventDefault();
    let data = new FormData(this.frmCreate.current);
    if (this.isEdit) {
      data.append("per_int_id", this.idrecurso);
    }
    axios({
      method: this.isEdit ? "post" : "post",
      url: baseUrl("cites/permisos"),
      // url: baseUrl('aro/documentos' + (this.isEdit ? `/${this.idrecurso}` : '')),
      // data: this.isEdit ? Object.fromEntries(data)  : data
      data: data,
    }).then((res) => {
      if (res.data.success) {
        this.frmCreate.current.reset();
        Swal.fire("Permisos", res.data.message, "success").then((sr) => {
          if (this.isEdit) {
            this.onClick_regresar();
            // this.props.history.push(localUrl('config/recursos'))
          }
        });
      }
    });
  };
  COptionRecursos = () => {
    return this.state.recursos.map((item, index) => {
      return (
        <option key={index} value={item.id}>
          {item.name}
        </option>
      );
    });
  };
  COptionTipo = () => {
    return this.state.tipo.map((item, index) => {
      return (
        <option key={index} value={item.id}>
          {item.name}
        </option>
      );
    });
  };
  COptionLenguaje = () => {
    return this.state.idioma.map((item, index) => {
      return (
        <option key={index} value={item.id}>
          {item.name}
        </option>
      );
    });
  };

  render() {
    return (
      <Templates.Default.BasePageRoute2
        localUrl={localUrl}
        dataPage={this.props.DataPage}
      >
        <div className="is-main-section">
          <Card>
            <Card.Header>
              <Card.Header.Title>
                <span className="icon">
                  <i className="fas fa-file-invoice"></i>
                </span>
                Datos
              </Card.Header.Title>
            </Card.Header>
            <Card.Content>
              <div
                ref={this.spinnerLoad}
                className="ld ld-spinner  ld-spin"
              ></div>
              <form
                ref={this.frmCreate}
                onSubmit={this.OnSubmit_create}
                className="is-hidden"
              >
                <div className="field is-horizontal">
                  <div className="field-label is-normal">
                    <label className="label">Año</label>
                  </div>
                  <div className="field-body">
                    <div className="field columns">
                      <div className="field column is-3">
                        <div className="control   is-clearfix">
                          <input
                            type="text"
                            placeholder="Año"
                            name="per_int_year"
                            required="required"
                            className="input form-control"
                            maxLength="10"
                          />
                        </div>
                        <p className="help">0 / 10 </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="field is-horizontal">
                  <div className="field-label is-normal">
                    <label className="label">Numero</label>
                  </div>
                  <div className="field-body">
                    <div className="field columns">
                      <div className="field column is-5">
                        <div className="control   is-clearfix">
                          <input
                            type="text"
                            placeholder="Numero"
                            name="per_text_number"
                            required="required"
                            className="input form-control"
                            maxLength="200"
                          />
                        </div>
                        <p className="help">0 / 200 </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="field is-horizontal">
                  <div className="field-label is-normal">
                    <label className="label">Tipo</label>
                  </div>
                  <div className="field-body">
                    <div className="field">
                      <div className="control">
                        <span className="select is-empty">
                          {/* disabled={ this.state.tipos.length === 0 } */}
                          <select required="required" name="per_text_type">
                            <option value="-1">- Seleccionar -</option>
                            {this.COptionTipo()}
                          </select>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="field is-horizontal">
                  <div className="field-label is-normal">
                    <label className="label">Fecha</label>
                  </div>
                  <div className="field-body">
                    <div className="field columns">
                      <div className="field column is-3">
                        <div className="control   is-clearfix">
                          <input
                            type="date"
                            name="per_text_date"
                            required="required"
                            className="input form-control"
                            maxLength="50"
                          />
                        </div>
                        <p className="help">0 / 50 </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="field is-horizontal">
                  <div className="field-label is-normal">
                    <label className="label">Situacion</label>
                  </div>
                  <div className="field-body">
                    <div className="field columns">
                      <div className="field column is-8">
                        <div className="control   is-clearfix">
                          <input
                            type="text"
                            placeholder="Situacion"
                            name="per_text_situation"
                            required="required"
                            className="input form-control"
                            maxLength="300"
                          />
                        </div>
                        <p className="help">0 / 300 </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="field is-horizontal">
                  <div className="field-label is-normal">
                    <label className="label">Fecha Situacion</label>
                  </div>
                  <div className="field-body">
                    <div className="field columns">
                      <div className="field column is-3">
                        <div className="control   is-clearfix">
                          <input
                            type="date"
                            name="per_text_datesituation"
                            required="required"
                            className="input form-control"
                            maxLength="50"
                          />
                        </div>
                        <p className="help">0 / 50 </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="field is-horizontal">
                  <div className="field-label is-normal">
                    <label className="label">Fecha Emision</label>
                  </div>
                  <div className="field-body">
                    <div className="field columns">
                      <div className="field column is-3">
                        <div className="control   is-clearfix">
                          <input
                            type="date"
                            name="per_text_dateemission"
                            required="required"
                            className="input form-control"
                            maxLength="50"
                          />
                        </div>
                        <p className="help">0 / 50 </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="field is-horizontal">
                  <div className="field-label is-normal">
                    <label className="label">Exportador</label>
                  </div>
                  <div className="field-body">
                    <div className="field columns">
                      <div className="field column is-8">
                        <div className="control   is-clearfix">
                          <input
                            type="text"
                            placeholder="Exportador"
                            name="per_text_exporter"
                            required="required"
                            className="input form-control"
                            maxLength="300"
                          />
                        </div>
                        <p className="help">0 / 300 </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="field is-horizontal">
                  <div className="field-label is-normal">
                    <label className="label">Pais Exportador</label>
                  </div>
                  <div className="field-body">
                    <div className="field columns">
                      <div className="field column is-4">
                        <div className="control   is-clearfix">
                          <input
                            type="text"
                            placeholder="Pais Exportador"
                            name="per_text_exportercountry"
                            required="required"
                            className="input form-control"
                            maxLength="300"
                          />
                        </div>
                        <p className="help">0 / 300 </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="field is-horizontal">
                  <div className="field-label is-normal">
                    <label className="label">Ciudad Exportador</label>
                  </div>
                  <div className="field-body">
                    <div className="field columns">
                      <div className="field column is-5">
                        <div className="control   is-clearfix">
                          <input
                            type="text"
                            placeholder="Ciudad Exportador"
                            name="per_text_exportercity"
                            required="required"
                            className="input form-control"
                            maxLength="300"
                          />
                        </div>
                        <p className="help">0 / 300 </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="field is-horizontal">
                  <div className="field-label is-normal">
                    <label className="label">Codigo Pais Exportador</label>
                  </div>
                  <div className="field-body">
                    <div className="field columns">
                      <div className="field column is-2">
                        <div className="control   is-clearfix">
                          <input
                            type="text"
                            placeholder="Isocode"
                            name="per_text_exportcountry"
                            required="required"
                            className="input form-control"
                            maxLength="300"
                          />
                        </div>
                        <p className="help">0 / 300 </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="field is-horizontal">
                  <div className="field-label is-normal">
                    <label className="label">Importador</label>
                  </div>
                  <div className="field-body">
                    <div className="field columns">
                      <div className="field column is-8">
                        <div className="control   is-clearfix">
                          <input
                            type="text"
                            placeholder="Importador"
                            name="per_text_importer"
                            required="required"
                            className="input form-control"
                            maxLength="300"
                          />
                        </div>
                        <p className="help">0 / 300 </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="field is-horizontal">
                  <div className="field-label is-normal">
                    <label className="label">Pais Importador</label>
                  </div>
                  <div className="field-body">
                    <div className="field columns">
                      <div className="field column is-4">
                        <div className="control   is-clearfix">
                          <input
                            type="text"
                            placeholder="Pais Importador"
                            name="per_text_importercountry"
                            required="required"
                            className="input form-control"
                            maxLength="300"
                          />
                        </div>
                        <p className="help">0 / 300 </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="field is-horizontal">
                  <div className="field-label is-normal">
                    <label className="label">Ciudad Exportador</label>
                  </div>
                  <div className="field-body">
                    <div className="field columns">
                      <div className="field column is-5">
                        <div className="control   is-clearfix">
                          <input
                            type="text"
                            placeholder="Ciudad Importador"
                            name="per_text_importercity"
                            required="required"
                            className="input form-control"
                            maxLength="300"
                          />
                        </div>
                        <p className="help">0 / 300 </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="field is-horizontal">
                  <div className="field-label is-normal">
                    <label className="label">Codigo Pais Importador</label>
                  </div>
                  <div className="field-body">
                    <div className="field columns">
                      <div className="field column is-2">
                        <div className="control   is-clearfix">
                          <input
                            type="text"
                            placeholder="Isocode"
                            name="per_text_importcountry"
                            required="required"
                            className="input form-control"
                            maxLength="300"
                          />
                        </div>
                        <p className="help">0 / 300 </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="field is-horizontal">
                  <div className="field-label is-normal">
                    <label className="label">Operacion Objetivo</label>
                  </div>
                  <div className="field-body">
                    <div className="field columns">
                      <div className="field column is-8">
                        <div className="control   is-clearfix">
                          <input
                            type="text"
                            placeholder="Operacion Objetivo"
                            name="per_text_operationobjective"
                            required="required"
                            className="input form-control"
                            maxLength="300"
                          />
                        </div>
                        <p className="help">0 / 300 </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="field is-horizontal">
                  <div className="field-label is-normal">
                    <label className="label">Salida/Entrada Locacion</label>
                  </div>
                  <div className="field-body">
                    <div className="field columns">
                      <div className="field column is-5">
                        <div className="control   is-clearfix">
                          <input
                            type="text"
                            placeholder="Salida/Entrada Locacion"
                            name="per_text_inputoutputlocation"
                            required="required"
                            className="input form-control"
                            maxLength="300"
                          />
                        </div>
                        <p className="help">0 / 300 </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="field is-horizontal">
                  <div className="field-label is-normal">
                    <label className="label">Salida/Entrada Ciudad</label>
                  </div>
                  <div className="field-body">
                    <div className="field columns">
                      <div className="field column is-5">
                        <div className="control   is-clearfix">
                          <input
                            type="text"
                            placeholder="Salida/Entrada Ciudad"
                            name="per_text_inputoutputcity"
                            required="required"
                            className="input form-control"
                            maxLength="300"
                          />
                        </div>
                        <p className="help">0 / 300 </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="field is-horizontal">
                  <div className="field-label is-normal">
                    <label className="label">Salida/Entrada Fecha</label>
                  </div>
                  <div className="field-body">
                    <div className="field columns">
                      <div className="field column is-3">
                        <div className="control   is-clearfix">
                          <input
                            type="date"
                            name="per_text_inputoutputdate"
                            required="required"
                            className="input form-control"
                            maxLength="50"
                          />
                        </div>
                        <p className="help">0 / 50 </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="field is-horizontal">
                  <div className="field-label is-normal">
                    <label className="label">Observacion</label>
                  </div>
                  <div className="field-body">
                    <div className="field columns">
                      <div className="field column is-8">
                        <div className="control   is-clearfix">
                          <input
                            type="text"
                            placeholder="Observacion"
                            name="per_text_observation"
                            required="required"
                            className="input form-control"
                            maxLength="300"
                          />
                        </div>
                        <p className="help">0 / 300 </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="field is-horizontal">
                  <div className="field-label is-normal">
                    <label className="label">Producto</label>
                  </div>
                  <div className="field-body">
                    <div className="field columns">
                      <div className="field column is-5">
                        <div className="control   is-clearfix">
                          <input
                            type="text"
                            placeholder="Producto"
                            name="per_text_product"
                            required="required"
                            className="input form-control"
                            maxLength="300"
                          />
                        </div>
                        <p className="help">0 / 300 </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="field is-horizontal">
                  <div className="field-label is-normal">
                    <label className="label">Nombre Cientifico</label>
                  </div>
                  <div className="field-body">
                    <div className="field columns">
                      <div className="field column is-6">
                        <div className="control   is-clearfix">
                          <input
                            type="text"
                            placeholder="Nombre Cientifico"
                            name="per_text_taxon"
                            required="required"
                            className="input form-control"
                            maxLength="300"
                          />
                        </div>
                        <p className="help">0 / 300 </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="field is-horizontal">
                  <div className="field-label is-normal">
                    <label className="label">Apendice</label>
                  </div>
                  <div className="field-body">
                    <div className="field columns">
                      <div className="field column is-3">
                        <div className="control   is-clearfix">
                          <input
                            type="text"
                            placeholder="Apendice"
                            name="per_text_cite"
                            required="required"
                            className="input form-control"
                            maxLength="300"
                          />
                        </div>
                        <p className="help">0 / 300 </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="field is-horizontal">
                  <div className="field-label is-normal">
                    <label className="label">Origen</label>
                  </div>
                  <div className="field-body">
                    <div className="field columns">
                      <div className="field column is-3">
                        <div className="control   is-clearfix">
                          <input
                            type="text"
                            placeholder="Origen"
                            name="per_text_originspecies"
                            required="required"
                            className="input form-control"
                            maxLength="300"
                          />
                        </div>
                        <p className="help">0 / 300 </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="field is-horizontal">
                  <div className="field-label is-normal">
                    <label className="label">Parte de Especie</label>
                  </div>
                  <div className="field-body">
                    <div className="field columns">
                      <div className="field column is-5">
                        <div className="control   is-clearfix">
                          <input
                            type="text"
                            placeholder="Parte de Especie"
                            name="per_text_partspecies"
                            required="required"
                            className="input form-control"
                            maxLength="300"
                          />
                        </div>
                        <p className="help">0 / 300 </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="field is-horizontal">
                  <div className="field-label is-normal">
                    <label className="label">Cantidad</label>
                  </div>
                  <div className="field-body">
                    <div className="field columns">
                      <div className="field column is-3">
                        <div className="control   is-clearfix">
                          <input
                            type="number"
                            placeholder="Cantidad"
                            name="per_int_quantity"
                            required="required"
                            className="input form-control"
                            maxLength="20"
                          />
                        </div>
                        <p className="help">0 / 300 </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="field is-horizontal">
                  <div className="field-label is-normal">
                    <label className="label">Recurso</label>
                  </div>
                  <div className="field-body">
                    <div className="field">
                      <div className="control">
                        <span className="select is-empty">
                          <select required="required" name="rec_int_id">
                            <option value="-1">- Seleccionar -</option>
                            {this.COptionRecursos()}
                          </select>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="field is-horizontal">
                  <div className="field-label is-normal">
                    <label className="label">Unidad</label>
                  </div>
                  <div className="field-body">
                    <div className="field columns">
                      <div className="field column is-4">
                        <div className="control   is-clearfix">
                          <input
                            type="number"
                            placeholder="Unidad"
                            name="per_text_unit"
                            required="required"
                            className="input form-control"
                            maxLength="20"
                          />
                        </div>
                        <p className="help">0 / 300 </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="field is-horizontal">
                  <div className="field-label is-normal">
                    <label className="label">Idioma</label>
                  </div>
                  <div className="field-body">
                    <div className="field">
                      <div className="control">
                        <span className="select is-empty">
                          <select required="required" name="lan_txt_language">
                            <option value="-1">- Seleccionar -</option>
                            {this.COptionLenguaje()}
                          </select>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <hr />
                <div className="field is-horizontal">
                  <div className="field-label is-normal" />
                  <div className="field-body">
                    <div className="field">
                      <div className="field">
                        <div className="field-body">
                          <div className="field is-grouped">
                            <div className="control">
                              <button
                                type="submit"
                                className="button is-primary"
                              >
                                <span>Guardar</span>
                              </button>
                            </div>
                            <div className="control">
                              <button
                                type="button"
                                onClick={this.onClick_regresar}
                                className="button is-danger"
                              >
                                <span>Regresar</span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </Card.Content>
          </Card>
        </div>
      </Templates.Default.BasePageRoute2>
    );
  }
}
export default connect(getMapStateDefault(), {
  set_datapage,
  seDatatDocumentos,
  checkDataDirectorio,
})(PermisosCreate);
